import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React, { memo, useRef, useCallback, useMemo } from 'react';
import AriaLiveContext from './contexts/AriaLiveContext.js';

var _templateObject;
// Can't be display hidden, or
// assistive devices won't pick it up.
var AriaLiveRegion = styled__default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"])));
var AriaLiveProvider = function AriaLiveProvider(_ref) {
  var children = _ref.children;
  var ariaLiveRegionRef = useRef(null);
  var sendAriaLiveMessage = useCallback(function (msg) {
    if (ariaLiveRegionRef.current) {
      // Need to clear the old text region if it is identical,
      // to trigger a reaction from assistive technologies.
      if (ariaLiveRegionRef.current.textContent === msg) {
        ariaLiveRegionRef.current.textContent = '';
      }
      ariaLiveRegionRef.current.textContent = msg;
    }
  }, [ariaLiveRegionRef]);
  var ariaLiveContext = useMemo(function () {
    return {
      sendMessage: sendAriaLiveMessage
    };
  }, [sendAriaLiveMessage]);
  return /*#__PURE__*/React.createElement(AriaLiveContext.Provider, {
    value: ariaLiveContext
  }, /*#__PURE__*/React.createElement(AriaLiveRegion, {
    id: 'honest-aria-live',
    "data-testid": 'honest-aria-live',
    role: 'status',
    ref: ariaLiveRegionRef
  }), children);
};
var index = /*#__PURE__*/memo(AriaLiveProvider);

export default index;
